<script>
import Vue from "vue";
import Component from "vue-class-component";
import { mapGetters } from "vuex";

import Footer from "@/components/Footer";

import Nav from "@/components/Nav"

@Component({
  components: {
    Nav,
    Footer
  },
  computed: {
    ...mapGetters({
      userRole: "getUserRole",
      firstName: "getFirstName",
      currentPage: 'getCurrentPage'
    }),
    menuDisplay() {
      return this.expanded ? "x" : "menu";
    }
  }
})
export default class App extends Vue {
  expanded = false;
  shiftNav() {
    this.expanded = !this.expanded;
  }
  closeNav() {
    this.expanded = false;
  }
}
</script>

<template>
  <div id="app">
    <div>
      <Nav v-if="currentPage !== 'landing'" />
    </div>
    <div class="content">
      <router-view :key="$route.fullPath"></router-view>
    </div>
    <Footer />
  </div>
</template>

<style lang="scss" scoped>
.content {
  padding: 2em 1em;

  @media (min-width: 768px) {
    max-width: 100%;
    margin: 0 auto;
  }
}
</style>
